// noinspection ES6PreferShortImport
import type { Option } from "../internal/types.ts";
import { useCallback } from "react";

type LoadAsyncOptions = (search: string, page: number) => Promise<Option[]>;

export const useLoadAsyncOptions = (url: string): LoadAsyncOptions => {
  return useCallback(
    async (search, page): Promise<Option[]> => {
      const [actualUrl, queryString] = url.split("?");

      const urlSearchParams = new URLSearchParams(queryString);

      urlSearchParams.append("term", search.trim());
      urlSearchParams.append("page", page.toString());

      const result = await fetch(`${actualUrl}?${urlSearchParams.toString()}`, {
        method: "GET",
        headers: { Accept: "application/json" },
      });

      const { items } = await result.json();

      return items;
    },
    [url],
  );
};
